import React from 'react';
import { SectionHeader } from '../../../partner-pages/utils/section-header';
import SquareBox from './square-box';

const WhyUseClearTaxSection = () => {
  return (
    <div className="wg-container mt-24 mb-8">
      <div className="bg-grey-100 px-20 rounded-3xl pt-1.5 pb-20 sm:px-4">
        <SectionHeader
          heading={'Why use Cleartax to file your taxes ?'}
          align="center"
          description={undefined}
          className="font-semibold text-s-46 pt-16 sm:py-10 pb-14 md:text-s-32 sm:text-s-24"
        />
        <div className="flex gap-4 justify-center sm:flex-col">
          <div className="flex flex-col gap-4 w-1/2 h-full sm:w-full">
            <SquareBox
              boxClassName="bg-green-100 h-1/2"
              headingClassName="pb-[92px] lg:pb-[73px] sm:pb-10"
              imageClssName="sm:pb-10"
            />
            <SquareBox
              boxClassName="bg-yellow-250 h-1/2"
              headingClassName=""
              lottieUrl="https://assets.clear.in/cleartax/images/1757932394_visualize_tax_v4.json"
              imageClssName="pt-6 md:pt-7"
              heading="Visualize <br /> Tax Calculation"
              SemiCircleClassName="bg-[#FEF3E1]"
            />
          </div>
          <div className="flex flex-col gap-4 w-1/2 h-full sm:w-full">
            <SquareBox
              boxClassName="bg-red-100 h-1/2"
              headingClassName=""
              imageClssName="pt-6"
              lottieUrl="https://assets.clear.in/cleartax/images/1757755139_auto_appy_deductions.json"
              heading="Auto Apply <br /> Deductions"
            />
            <SquareBox
              boxClassName="bg-white border-[#EBEBEC] border-2 h-1/2"
              headingClassName="md:pb-[44px]"
              lottieUrl="https://assets.clear.in/cleartax/images/1757754996_uploadanything.json"
              heading="Upload anything & <br/> we’ll detect it."
            />
          </div>
          {/* <div className="w-1/2">
            <FavPlatformRectangle />
          </div> */}
        </div>
        {/* <AiChatBanner /> */}
        {/* <div className="flex gap-4 justify-center pb-24">
          <SquareBox
            boxClassName="bg-white border-[#EBEBEC] border-2"
            headingClassName="px-24 pt-10 pb-14"
            lottieUrl="https://assets.clear.in/cleartax/images/1757754996_uploadanything.json"
            heading="Upload anything & <br/> we’ll detect it."
          />
          <SquareBox
            boxClassName="bg-red-100"
            headingClassName="px-24 pt-16 pb-14"
            imageClssName="pt-6"
            lottieUrl="https://assets.clear.in/cleartax/images/1757755139_auto_appy_deductions.json"
            heading="Auto Apply <br /> Deductions"
          />
        </div> */}
      </div>
    </div>
  );
};

export default WhyUseClearTaxSection;
